import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const ECG = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.ecg'} />}
      newButton={
        <DocumentCreationButton
          name="ecg"
          text={'clinicalstudy.newecg'}
          onClick={startEdit({}, 'ecg')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.result'} />
            </Item>
            <Item xs={3}>
              <FormattedMessage id={'clinicalstudy.additionalInformation'} />
            </Item>
            <Item xs={5}>
              <FormattedMessage id={'clinicalstudy.ecgFollowUpRequired'} />
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {formatPartialDate(d.date)}
            </Item>
            <Item xs={2}>
              {d.result ? <FormattedMessage id={`clinicalstudy.opts.normalBorderlineAbnormal.${d.result}`} /> : '-'}
            </Item>
            <Item xs={3}>
              <div style={{ marginRight: '3rem', wordBreak: 'break-word' }}>{d.additionalInformation ?? '-'}</div>
            </Item>
            <Item xs={2}>
              {d.followUpRequired ? <FormattedMessage id={`clinicalstudy.opts.yesNo.${d.followUpRequired}`} /> : '-'}
            </Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'ecg'>[];
  startEdit: StartEdit;
}

export default ECG;
